var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointOneicon = function SvgPointOneicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.556 11.4V6.06l-1.18.66c-.04.02-.07.03-.1.03-.05 0-.08-.03-.08-.09V5.59c0-.06.04-.11.11-.15l1.65-.89c.05-.03.11-.05.16-.05h.56c.07 0 .1.03.1.1v6.8c0 .07-.03.1-.1.1h-1.02c-.07 0-.1-.03-.1-.1Z"
  })));
};
export default SvgPointOneicon;